<template>
  <div>
    <header>
      部门名称：
      <el-input
        v-model="searchKey"
        placeholder="请输入部门名称"
        style="width: 340px"
      ></el-input>
      状态：
      <el-select
        v-model="status"
        placeholder="请选择"
      >
        <el-option
          label="全部"
          :value="-1"
        > </el-option>
        <el-option
          label="有效"
          :value="1"
        > </el-option>
        <el-option
          label="无效"
          :value="2"
        > </el-option>
      </el-select>
      <el-button
        type="primary"
        icon="el-icon-search"
        style="margin-left: 10px"
        @click="handlerSearch"
      >查询</el-button>
      <el-button
        type="primary"
        @click="open"
      >新增</el-button>
    </header>
    <el-table
      :data="tableData"
      border
      style="width: 100%; margin-top: 20px"
    >
      <el-table-column
        type="index"
        label="序号"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="departmentName"
        label="部门名称"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="userCount"
        label="部门人员"
        align="center"
      >
      </el-table-column>
      <el-table-column
        label="状态"
        align="center"
      >
        <template slot-scope="scope">
          {{scope.row.status == 1 ?'有效':'无效'}}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="edit(scope.row)"
          >编辑</el-button>
          <el-button
            type="text"
            @click="handleDel(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div
      class="tc"
      style="margin-top:20px"
    >
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[ 10, 20, 50]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      >
      </el-pagination>
    </div>

    <el-dialog
      :title="editId?'编辑':'新增'"
      :visible.sync="addDialogVisible"
      width="40%"
      center
      :close-on-click-modal="false"
      @close="dialogCloseFun"
    >
      <el-form
        ref="ruleForm"
        :model="trainForm"
        label-width="160px"
        :rules="rules"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="部门名称:"
              prop="departmentName"
            >
              <el-input v-model="trainForm.departmentName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="显示顺序:">
              <el-input v-model="trainForm.sort"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item
              label="有效状态:"
              prop="status"
            >
              <el-radio
                v-model="trainForm.status"
                :label="1"
              >有效</el-radio>
              <el-radio
                v-model="trainForm.status"
                :label="2"
              >无效</el-radio>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>

          <el-button
            type="primary"
            @click="submitForm('ruleForm')"
          >确定</el-button>
          <el-button @click="resetForm('ruleForm')">取消</el-button>

        </el-form-item>

      </el-form>

    </el-dialog>

    <authorization
      :isShow="authorizationShow"
      @isShow='closeAuthor'
    />

  </div>
</template>

<script>
import {
  provinceAndCityData
} from 'element-china-area-data'
import authorization from '@/components/authorization.vue'
import {
  Api_depart
} from '@/api/api'
import { getStore } from '@/util/store'
import mixin_dialog from '@/mixins/dialog.js';
export default {
  components: {
    authorization
  },
  mixins: [mixin_dialog],
  data() {
    return {
      options: provinceAndCityData,
      selectedOptions: [],
      searchKey: "",
      status: -1,
      authorizationShow: false,
      projectId: getStore({ name: 'projectId' }),
      tableData: [],
      currentPage: 1,
      pagesize: 10,
      totalCount: 0,
      addDialogVisible: false,
      trainForm: {
        departmentName: '',
        sort: '',
        status: 1,
      },
      rules: {
        departmentName: [{
          required: true,
          message: "请输入部门名称",
          trigger: "blur",
        }],
        status: [{
          required: true,
          message: "请选择有效状态",
          trigger: "blur",
        }],
      },
      departId: '',
      companyId: getStore({ name: 'companyId' }),
      editId: 0,
    };
  },
  created() {
    this.handlerSearch()
  },
  methods: {
    edit(val) {
      this.editId = val.id
      Api_depart.detail(val.id).then(res => {
        this.trainForm = res.data.data
        this.addDialogVisible = true
      })
    },
    handleSizeChange(size) {
      this.pagesize = size;
      this.handlerSearch()
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.handlerSearch()
    },
    closeAuthor(val) {
      this.authorizationShow = val
    },
    open(val) {
      // this.resetForm()
      this.trainForm = {
        departmentName: '',
        sort: '',
        status: 1,
      }
      this.addDialogVisible = true
    },
    handleDel(val) {
      this.$confirm('是否删除此部门?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Api_depart.delDepart(val.id).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.handlerSearch()
        })
      })
    },
    handleChange(value) {
      console.log(value)
    },
    handlerSearch() {
      let params = {
        status: this.status,
        departmentName: this.searchKey,
        companyId: this.companyId,
        projectId: this.projectId,
        pageSize: this.pagesize,
        pageIndex: this.currentPage
      }
      Api_depart.getDepartList(params).then(res => {
        const result = res.data
        if (result.statusCode == 200) {
          this.tableData = result.data.tList
          this.totalCount = result.data.totalCount
        }
      })
    },
    addDepart() {
      let params = {
        departmentName: this.trainForm.departmentName,
        projectId: this.projectId,
        status: this.trainForm.status,
        sort: Number(this.trainForm.sort),
        authorityCompanyId: this.companyId
      }
      if (this.trainForm.id) {
        params.id = this.trainForm.id
        Api_depart.editDepart(params).then(res => {
          this.addDialogVisible = false
          const result = res.data
          if (result.statusCode == 200) {
            this.handlerSearch()
          }
        })
      } else {
        Api_depart.addDepart(params).then(res => {
          this.addDialogVisible = false
          const result = res.data
          if (result.statusCode == 200) {
            this.handlerSearch()
          }
        })
      }

    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addDepart()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm() {
      this.addDialogVisible = false
      this.trainForm = {}
      this.departId = ''
      this.editId = 0;
    },
  },
};
</script>